import React from 'react';

import {DatePicker, Switch} from 'antd';
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import {AvField, AvForm} from "availity-reactstrap-validation";
const SystemSettings = () => {
    const onChange = (checked) => {
        // console.log(`switch to ${checked}`);
    };
    const prepareObject = (values) => {

    }
    return (
        <div className="user-management">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Management</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Settings</span>
            </div>
            <div className="camera-config-content">
                <h5 className="text-white mb-4">Time Synchronization</h5>
                <div className="d-flex">
                    <span className="text-white mr-24">Device Time</span>
                    <span className="text-white">2024-01-30 20:32:39</span>
                </div>
                <div className="d-flex mt-3">
                    <span className="text-white mr-24">ONVIF Time Synchronization</span>
                    <Switch defaultChecked onChange={onChange} />
                </div>

                <h6 className="text-white mt-4">
                    Time Synchronization
                    <div className="row">
                        <div className="col-md-6">
                            <div className="inputs-box for-select">
                                <FormControl
                                    className="w-100"
                                >

                                    <RadioGroup
                                        row
                                        // onChange={(e) => setSendData({...sendData, gender: e.target.value})}
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        className="w-100"
                                    >
                                        <div className="w-100 mt-3">
                                            <div className="d-flex  bas-date">
                                                    <FormControlLabel value="manual" control={<Radio/>} label="Manual settings"/>


                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DemoContainer components={['DateTimePicker']}>
                                                                <DateTimePicker label="" className="text-white" />
                                                            </DemoContainer>
                                                        </LocalizationProvider>

                                            </div>
                                            <div className="d-flex align-items-start mt-5">
                                                    <FormControlLabel value="ntp" control={<Radio/>} label="NTP Synchronization "/>
                                                    <div className="my-avform">
                                                        <AvForm onValidSubmit={(e, v) => prepareObject(v)}>
                                                            <AvField
                                                                name="Time"
                                                                label="Time Server "
                                                                // value={item.value ? item.value : ""}
                                                                placeholder="text"
                                                            />
                                                            <AvField
                                                                name="Update"
                                                                label="Update Interval "
                                                                // value={item.value ? item.value : ""}
                                                                placeholder="text"
                                                            />
                                                            <AvField
                                                                name="Zone"
                                                                label="Time Zone"
                                                                // value={item.value ? item.value : ""}
                                                                placeholder="text"
                                                            />


                                                        </AvForm>

                                                    </div>
                                                </div>
                                        </div>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="d-flex justify-content-end">
                                <button className="add-btn">Change password</button>
                            </div>
                        </div>
                        <div className="col-md-6"></div>
                    </div>
                </h6>
            </div>

        </div>
    );
};

export default SystemSettings;